import type { FC, ReactNode } from 'react'

import Image from 'next/image'
import { Marquee } from '@/components/generals/marquee'
import { siteConfig } from '@/constants/site'

interface HeroSectionProps {
    image: string | null
}

const NAME_COPIES = 2

export const HeroSection: FC<HeroSectionProps> = ({ image }): ReactNode => {
    return (
        <section id='hero' aria-labelledby='hero-title' className='w-full bg-background px-2 md:px-8'>
            <h1 id='hero-title' className='sr-only'>
                {siteConfig.name}, freelance website designer and app developer
            </h1>

            <div className='mx-auto w-full max-w-site pt-4 pb-12 md:py-16 lg:py-20'>
                <div className='relative isolate flex aspect-video min-h-[60vh] w-full overflow-hidden rounded-hero bg-brand-night md:min-h-[85vh]'>
                    {image && (
                        <Image
                            src={image}
                            alt='Designer working late on a laptop in a dark studio lit by a blue screen'
                            fill
                            sizes='(min-width: 1232px) 1168px, 100vw'
                            loading='eager'
                            fetchPriority='high'
                            className='z-0 object-cover animate-in fade-in duration-1000'
                        />
                    )}

                    <div className='absolute inset-0 z-10 bg-linear-to-t from-black/40 to-black/15' aria-hidden='true' />

                    <div className='absolute inset-x-0 bottom-8 z-20 overflow-hidden md:bottom-12 lg:bottom-20' aria-hidden='true'>
                        <Marquee duration={NAME_COPIES * 25}>
                            {Array.from({ length: NAME_COPIES }, (_, index) => (
                                <span
                                    key={index}
                                    className='pr-5 font-heading text-mega font-medium whitespace-nowrap text-white md:pr-10 lg:pr-[4.3rem]'
                                >
                                    {siteConfig.name}
                                </span>
                            ))}
                        </Marquee>
                    </div>
                </div>
            </div>
        </section>
    )
}
